import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Payment} from '../model/Entities/Payment';

@Injectable()
export class PaymentService extends ApiService<Payment> {

    protected apiUrl = 'api/payments';

    protected getObjectType(): any {
        return Payment;
    }

}




// WEBPACK FOOTER //
// /app/src/services/payment.service.ts